export const DEPOSIT_DIVERGENCE_RANGES = [
  { value: "0-100", label: "Até R$ 100,00" },
  { value: "100-500", label: "R$ 100,00 — R$ 500,00" },
  { value: "500-1000", label: "R$ 500,00 — R$ 1.000,00" },
  { value: "1000-5000", label: "R$ 1.000,00 — R$ 5.000,00" },
  { value: "5000+", label: "Acima de R$ 5.000,00" },
];

// O limite superior das faixas é exclusivo: um valor de R$ 100,00 pertence
// à faixa "100-500", não à faixa "0-100". Como o backend filtra com
// maxDivergence inclusivo (<=), enviamos o teto reduzido em um centavo para
// que as faixas não se sobreponham na fronteira.
const RANGE_BOUNDARY_STEP = 0.01;

export function parseDivergenceRange(
  range: string | undefined,
): { minDivergence?: number; maxDivergence?: number } {
  if (!range) return {};
  if (range === "5000+") return { minDivergence: 5000 };
  const [min, max] = range.split("-").map(Number);
  return { minDivergence: min, maxDivergence: max - RANGE_BOUNDARY_STEP };
}
